import { projectCall } from './helpers/tutorCalls';

export const CorpusApi = {
    getCorpuses: function () {
        return projectCall('getCorpuses', {});
    },
    getCorpuseDocuments: function (corpusId: string) {
        if ((window as any).fakeCorpusDocs) {
            return new Promise((resolve) => {
                resolve((window as any).fakeCorpusDocs);
            });
        }

        return projectCall('getCropusDocuments', { corpusId });
    },
    getCorpusDocument: function (corpusId: string, documentId: string) {
        if ((window as any).fakeCorpusDocument) {
            return new Promise((resolve) => {
                resolve((window as any).fakeCorpusDocument);
            });
        }
        return projectCall('getCropusDocument', { corpusId, documentId });
    },
    searchByCorpus: function (corpusId: string, query: string, question: string, maxTokens: number) {
        if ((window as any).fakeCorpusSearch) {
            return new Promise(resolve => {
                setTimeout(() => {
                    resolve((window as any).fakeCorpusSearch);
                }, 1000);
            });
        }

        return projectCall('corpusSearch', { corpusId, query, question, maxTokens });
    },

};